export type TestComponentStates = 'startTest' | 'inProgress' | 'testFailed' | 'testPassed';

export type TestProgress = 'loading' | 'failed' | 'success' | 'default';

export type TestType = 'api-reachable' | 'api-responsive' | 'access-youtube' | 'access-h5p';

export interface TestCheckPoints {
  id: number;
  text: string;
  type: TestType;
}

export const testCheckPoints: TestCheckPoints[] = [
  {
    id: 0,
    text: 'Test if backend API is reachable',
    type: 'api-reachable',
  },
  {
    id: 1,
    text: 'Test if backend API is responsive',
    type: 'api-responsive',
  },
  {
    id: 2,
    text: 'Test if user can access youtube',
    type: 'access-youtube',
  },
  {
    id: 3,
    text: 'Test if user can access h5p',
    type: 'access-h5p',
  },
];

export const TestComponentStatesData = {
  startTest: {
    title: 'Start Test',
    description: 'See if KnoPro will work on your device',
    buttonText: 'Start Test',
  },
  inProgress: {
    title: 'Testing In Progress',
    description: testCheckPoints,
    buttonText: 'Stop Test',
  },
  testFailed: {
    title: 'Test Failed',
    description: testCheckPoints,
    buttonText: "Go To FAQ's",
  },
  testPassed: {
    title: 'Success!',
    description: testCheckPoints,
    buttonText: 'Go To KnoPro',
  },
};
